export default {
  'register.title': '會員註冊',
  'register.phone': '手機號',
  'register.phone.required': '請輸入手機號',
  'register.phone.format': '請輸入以04開頭的澳洲手機號',
  'register.phone.placeholder': '請輸入手機號（例如：0412345678）',
  'register.phone.verify': '驗證碼',
  'register.phone.verify.get': '獲取驗證碼',
  'register.phone.verify.required': '請輸入驗證碼',
  'register.phone.verify.sent': '驗證碼發送成功',
  'register.phone.verify.failed': '驗證碼發送失敗',
  'register.phone.verify.invalid': '驗證碼無效',
  'register.firstName': '名',
  'register.firstName.required': '請輸入名字',
  'register.middleName': '中間名',
  'register.lastName': '姓',
  'register.lastName.required': '請輸入姓氏',
  'register.email': '郵箱',
  'register.email.placeholder': '選填',
  'register.email.placeholder.required': '請輸入郵箱',
  'register.email.required': '請輸入郵箱',
  'register.email.invalid': '請輸入有效的郵箱地址',
  'register.birthday': '生日',
  'register.birthday.placeholder': '選擇生日',
  'register.ageGroup': '年齡段',
  'register.ageGroup.required': '請選擇年齡段',
  'register.ageGroup.placeholder': '請選擇您的年齡段',
  'register.ageGroup.under-18': '小於18歲',
  'register.ageGroup.18-25': '18-25歲',
  'register.ageGroup.26-35': '26-35歲',
  'register.ageGroup.36-45': '36-45歲',
  'register.ageGroup.46-55': '46-55歲',
  'register.ageGroup.56-65': '56-65歲',
  'register.ageGroup.65+': '65歲以上',
  'register.password': '密碼',
  'register.password.required': '請輸入密碼',
  'register.password.min': '密碼長度不能少於6位',
  'register.password.max': '密碼長度不能超過16位',
  'register.password.confirm': '確認密碼',
  'register.password.confirm.required': '請確認密碼',
  'register.password.confirm.mismatch': '兩次輸入的密碼不一致',
  'register.submit': '註冊',
  'register.success': '註冊成功',
  'register.fail': '註冊失敗，請重試',
}; 